import React from 'react';
import TableView from '../tableView';
import { LicensesResult } from '../../Model/contact';
import { useTranslation } from 'react-i18next';
interface Props {
  licenses: LicensesResult[],
  tabulator: any,
  filterSelectOptions: {},
  formatDate: (value: any) => void
}

export const LicensesTable = ({
  filterSelectOptions,
  licenses,
  tabulator,
  formatDate
}: Props) => {
  const { t } = useTranslation();
  const licenseColumns = [
    {
      title: t('ACTIVATION_DATE'),
      field: 'activationDate',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions,
      formatter: (cell: any) => formatDate(cell.getValue())
    },
    {
      title: t('EXPIRATION_DATE'),
      field: 'expirationDate',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions,
      formatter: (cell: any) => formatDate(cell.getValue())
    },
    {
      title: t('SENSOR_ID'),
      field: 'sensorId',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('TYPE'),
      field: 'type',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    }
  ];


  return <>  {licenses.length > 0
    ? <TableView
      t={t}
      ref={tabulator}
      data={licenses}
      columns={licenseColumns}
      id={'boughtProduct-list'} />
    : <p className='noData'>{t('NO_DATA')}</p>}
    </>;
};
